import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Contact from './components/contact';
import {useDispatch, useSelector} from 'react-redux';
import Loader from "../../../../../../../../components/sprite/components/loader";
import T1 from "./components/t1";
import ListOfContactsTitle from './components/list-of-contacts-title';
import UpgradeToBusiness from './components/upgrade-to-business';
import NewContactsLoading from './components/new-contacts-loading';
import ReturnToLabelsButton
	from '../../../../../../../../components/header/components/msg-bar/components/return-to-labels-button';
import Button from '../../../../../../../../components/button';
import {
	findNextContacts,
	loadNextContacts as setLoadNextContacts
} from '../../../../../../../../../actions/contactActions';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './index.css'

function ListOfContactsBodyContent () {
	const [scrollTop, setScrollTop] = useState(0);
	const [viewportHeight, setViewportHeight] = useState(0);

    const { t } = useTranslation();

	const isLoadingContacts = useSelector(state => state.contactReducer.isLoadingContacts);
    const isSearchingContacts = useSelector(state => state.contactReducer.isSearchingContacts);
    const confirmContactResearch = useSelector(state => state.contactReducer.confirmContactResearch);
    const contactSearchResult = useSelector(state => state.contactReducer.contactSearchResult);
    const findContacts = useSelector(state => state.contactReducer.findContacts);
    const selectedContactsGroup = useSelector(state => state.contactsGroupItemReducer.getSelectedContactsGroup);
    const findLabels = useSelector(state => state.contactsGroupItemReducer.findLabels);
    const hasContactsManagementPermission = useSelector(state => state.permissionReducer.hasContactsManagementPermission);
    const guidedTours = useSelector(state => state.guidedToursReducer.guidedTours);
    const isLabelSelectedOnMobile = useSelector(state => state.mobileReducer.isLabelSelectedOnMobile);
	const waitingContactsGroupsLevel = useSelector(state => state.contactsGroupItemReducer.waitingContactsGroupsLevel);
	const waitingDirectoryGroupsLevel = useSelector(state => state.directoryGroupReducer.waitingDirectoryGroupsLevel);
    const loadNextContacts = useSelector(state => state.contactReducer.loadNextContacts);
	const contactsPageSize = useSelector(state => state.contactReducer.contactsPageSize);
	const contactsPageNumber = useSelector(state => state.contactReducer.contactsPageNumber);

    const viewportMarginTop = 45;
	const rowHeight = 170;
	const amountRowsBuffered = 2;

	const dispatch = useDispatch();

    useEffect(() => {
	    window.addEventListener('resize', handleResize);
	    setViewportHeight(document.querySelector('.list-of-contacts-body-content').getBoundingClientRect().height);

	    return () => {
		    window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
    	if(loadNextContacts){
    		if(selectedContactsGroup){
			    dispatch(findNextContacts(selectedContactsGroup.id, selectedContactsGroup.ownerId, contactsPageSize, contactsPageNumber + 1))
		    }
	    }
    }, [dispatch, selectedContactsGroup, loadNextContacts, contactsPageSize, contactsPageNumber]);

    const handleResize = () => {
	    setViewportHeight(document.querySelector('.list-of-contacts-body-content').getBoundingClientRect().height);

	    /*
	    * Remove all active contact from mobile
	    * */

	    document.querySelectorAll('.contact.active').forEach(item => {
		    item.classList.remove('active');
	    });

	    /*
	    * Remove all contact actions re-position
	    * */

	    document.querySelectorAll('.contact-actions').forEach(item => {
		    item.removeAttribute('style');
	    });
    };

	const update = (e) => {
		setScrollTop(e.target.scrollTop);
		if(e.target.scrollTop > (e.target.children[0].scrollHeight - e.target.clientHeight) / 2) {
			if(!loadNextContacts){
				dispatch(setLoadNextContacts(true));
			}
		}
	};

	const renderContactCardSkeleton = () => {
		const cardCount = Math.min(Math.max(Math.floor((viewportHeight || 600) / 140), 3), 6);
		return (
			<div style={{ position: 'relative', overflowX: 'hidden' }}>
				<ListOfContactsTitle />
				{isLabelSelectedOnMobile && <ReturnToLabelsButton />}
				<div style={{ padding: '0 1em' }}>
					{Array(cardCount).fill("").map((_, index) => (
						<div
							key={index}
							style={{
								border: '1px solid #e5e5e5',
								borderRadius: '4px',
								backgroundColor: '#fff',
								marginBottom: '1rem',
								overflow: 'hidden'
							}}
						>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									padding: '0.5em 1em',
									minHeight: '100px'
								}}
							>
								{/* Checkbox placeholder */}
								<div style={{ width: '16px', marginRight: '1rem', flexShrink: 0 }}>
									<Skeleton width={16} height={16} borderRadius={3} />
								</div>
								{/* Avatar placeholder */}
								<div style={{ width: '48px', height: '48px', marginRight: '1rem', flexShrink: 0 }}>
									<Skeleton circle width={48} height={48} />
								</div>
								{/* Name, Org, Role lines */}
								<div style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: '180px', flexGrow: 1, maxWidth: '40%' }}>
									<Skeleton width={index % 2 === 0 ? '75%' : '60%'} height={16} borderRadius={3} />
									<Skeleton width={index % 2 === 0 ? '90%' : '80%'} height={12} borderRadius={3} />
									<Skeleton width={index % 2 === 0 ? '65%' : '50%'} height={12} borderRadius={3} />
								</div>
								{/* Label badge pill */}
								<div className="d-none d-md-flex" style={{ marginLeft: 'auto', marginRight: '2rem', alignItems: 'center' }}>
									<Skeleton width={140} height={22} borderRadius={11} />
								</div>
								{/* 3 dots menu button */}
								<div style={{ width: '16px', display: 'flex', justifyContent: 'center' }}>
									<Skeleton width={6} height={20} borderRadius={3} />
								</div>
							</div>

							{/* Footer with action buttons */}
							<div
								style={{
									display: 'flex',
									justifyContent: 'flex-end',
									alignItems: 'center',
									padding: '0.4em 1em',
									borderTop: '1px solid #e5e5e5',
									backgroundColor: '#fafafa',
									gap: '8px'
								}}
							>
								<Skeleton width={26} height={26} borderRadius={13} />
								<Skeleton width={26} height={26} borderRadius={13} />
								<Skeleton width={26} height={26} borderRadius={13} />
							</div>
						</div>
					))}
				</div>
			</div>
		);
	};

    const contactListDisplay = () => {
        if(isSearchingContacts && confirmContactResearch){
            return (
                <div className="p-3">
                    <Loader/>
                </div>
            )
        } else if (contactSearchResult && confirmContactResearch) {
            if(contactSearchResult.contacts.length > 0){

	            let totalRows = contactSearchResult.contacts.length;

	            let indexStart = Math.max(
		            Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
		            0
	            );

	            let indexEnd = Math.min(
		            Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
		            amountRowsBuffered,
		            totalRows - 1
	            );

                return (
	                <div
		                style={{
			                position: 'relative',
			                height: viewportMarginTop + rowHeight * totalRows,
			                overflowX: 'hidden'
		                }}
	                >
                        <ListOfContactsTitle contactsResults={true} />
		                {
			                isLabelSelectedOnMobile && <ReturnToLabelsButton/>
		                }
                        {
	                        contactSearchResult.contacts.slice(indexStart, indexEnd + 1).map(item => (
                                <Contact
                                    key={item.id}
                                    id={item.id}
                                    name={item.name}
                                    email={item.email}
                                    emails={item.emails}
                                    hasImage={item.hasImage}
                                    picture={item.picture}
                                    phoneNumber={item.phoneNumber}
                                    company={item.company}
                                    jobTitle={item.jobTitle}
                                    department={item.department}
                                    labels={item.groups}
                                    type={item.type}
                                    fromAutocomplete={true}
                                    shareable={item.shareable}
                                    editable={item.editable}
                                    deletable={item.deletable}
                                    note={item.note}
                                    totalComments={item.totalComments}
                                    lastComment={item.lastComment}
                                    rowStyle={{height: rowHeight, top: viewportMarginTop + item.position * rowHeight - rowHeight}}
                                />
                            ))
                        }
                    </div>
                )
            } else {
                return (
                    <div className="p-3">
                        {t("noContactText")}.
                    </div>
                )
            }
        } else {
            if(isLoadingContacts || findContacts === null) {
                return renderContactCardSkeleton();
            }

            if(findContacts.contacts.length > 0){

	                let totalRows = findContacts.contacts.length;

	                let indexStart = Math.max(
		                Math.floor(scrollTop / rowHeight) - amountRowsBuffered,
		                0
	                );

	                let indexEnd = Math.min(
		                Math.ceil((scrollTop + viewportHeight) / rowHeight - 1) +
		                amountRowsBuffered,
		                totalRows - 1
	                );

	                if(isLoadingContacts){
	                	return (
			                <div className="p-3">
				                <Loader/>
			                </div>
		                )
	                }

                    return (
	                    <div
		                    style={{
			                    position: 'relative',
			                    height: viewportMarginTop + rowHeight * totalRows,
			                    overflowX: 'hidden'
		                    }}
	                    >
	                        <ListOfContactsTitle />
		                    {
			                    isLabelSelectedOnMobile && <ReturnToLabelsButton/>
		                    }
                            {
	                            findContacts.contacts.slice(indexStart, indexEnd + 1).map(item => {
                                    return (
                                        <Contact
                                            key={item.id}
                                            id={item.id}
                                            name={item.name}
                                            email={item.email}
                                            emails={item.emails}
                                            hasImage={item.hasImage}
                                            picture={item.picture}
                                            phoneNumber={item.phoneNumber}
                                            company={item.company}
                                            jobTitle={item.jobTitle}
                                            department={item.department}
                                            labels={item.groups}
                                            type={item.type}
                                            shareable={item.shareable}
                                            editable={item.editable}
                                            deletable={item.deletable}
                                            note={item.note}
                                            totalComments={item.totalComments}
                                            lastComment={item.lastComment}
                                            rowStyle={{height: rowHeight, top: viewportMarginTop + item.position * rowHeight - rowHeight}}
                                        />
                                    )
                                })
                            }
                        </div>
                    )
                } else {
                    if(
                    	(selectedContactsGroup.type === 'directory' || selectedContactsGroup.type === 'childDirectory' || selectedContactsGroup.type === 'childDirectoryLv2')
	                    && findContacts.directorySyncStatus === 'RUNNING'
                    ){
                        return (
	                        <div className="p-3">
		                        <Loader/>
		                        {
			                        waitingDirectoryGroupsLevel > 0 && <div className="text-center"><p>A few more seconds …</p></div>
		                        }
		                        {
			                        waitingDirectoryGroupsLevel > 1 && <div className="text-center">Taking too long? <Button onClick={() => window.location.reload()} className="btn-link font-weight-normal p-0">Reload the page</Button></div>
		                        }
	                        </div>
                        )
                    } else if (
                    	(selectedContactsGroup.type === "contact" || selectedContactsGroup.type === "childContact" || selectedContactsGroup.type === "childContactLv2")
	                    && findLabels.state === 'RUNNING') {
	                    return (
		                    <div className="p-3">
			                    <Loader/>
			                    {
				                    waitingContactsGroupsLevel > 0 && <div className="text-center"><p>A few more seconds …</p></div>
			                    }
			                    {
				                    waitingContactsGroupsLevel > 1 && <div className="text-center">Taking too long? <Button onClick={() => window.location.reload()} className="btn-link font-weight-normal p-0">Reload the page</Button></div>
			                    }
		                    </div>
	                    )
                    } else {
	                    return (
		                    <div className="p-3">
			                    {t("noContactText")}.
		                    </div>
	                    )
                    }
                }
        }
    };

    return (
        <div className="list-of-contacts-body-content" onScroll={ update }>

            {!hasContactsManagementPermission && <UpgradeToBusiness/>}

            {
                findLabels !== null && findLabels.contactsGroups.length === 0 && guidedTours.t1 === false
                    ?
                        <T1/>
                    :
                        null
            }
            {
                contactListDisplay()
            }
	        {
		        selectedContactsGroup && selectedContactsGroup.type !== 'directory'
		        && findContacts
		        && findContacts.contacts.length < findContacts.pages.totalRecords
		        && loadNextContacts
		        && <NewContactsLoading contacts={findContacts}/>
	        }
	        {
		        selectedContactsGroup && selectedContactsGroup.type === 'directory'
		        && findContacts
		        && findContacts.directorySyncStatus === 'RUNNING'
		        && <NewContactsLoading />
	        }
        </div>
    );
}

export default ListOfContactsBodyContent;
